import type { IActiveTime } from '../../../models/active-time.model';
import { Weekday } from '../../../models/weekday.enum';

const weekdayMap: Partial<Record<string, Weekday>> = {
  Monday: Weekday.Monday,
  Tuesday: Weekday.Tuesday,
  Wednesday: Weekday.Wednesday,
  Thursday: Weekday.Thursday,
  Friday: Weekday.Friday,
  Saturday: Weekday.Saturday,
  Sunday: Weekday.Sunday,
};

export default class ActiveTimeApiModel {
  public static mapToBusinessModel(apiModel: ActiveTimeApiModel): IActiveTime {
    return {
      from: apiModel.from,
      to: apiModel.to,
      days: (apiModel.days ?? []).map((day) => weekdayMap[day]).filter((day): day is Weekday => day !== undefined),
    };
  }

  from: string | undefined;
  to: string | undefined;
  days: string[] | undefined;
}
